import { render, staticRenderFns } from "./Type6a.vue?vue&type=template&id=183eb1a4&"
import script from "./Type6a.vue?vue&type=script&lang=js&"
export * from "./Type6a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports